import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './lib/analytics';

// Initialize analytics early so events fired during app bootstrap are captured.
// No-op unless VITE_POSTHOG_KEY is set (so dev/test don't send data).
initAnalytics();

// Start MSW worker in development (disabled for local API development)
async function enableMocking() {
  // Disable MSW when using local API
  return;

  // Uncomment below to enable MSW mocking
  /*
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  console.log('[MSW] Starting Mock Service Worker...');

  // Start the worker
  return worker.start({
    onUnhandledRequest: (req, print) => {
      console.log('[MSW] Unhandled request:', req.url);
      print.warning();
    },
  });
  */
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
